import script from "./SearchReturnSlip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchReturnSlip.vue?vue&type=script&setup=true&lang=ts"

import "./SearchReturnSlip.vue?vue&type=style&index=0&id=56c2c69c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c2c69c"]])

export default __exports__